import { defineComponent, ref, computed, resolveComponent, openBlock, createElementBlock, normalizeClass, createBlock, mergeProps, createCommentVNode, createElementVNode, renderSlot, Fragment, createVNode, withModifiers } from 'vue';
import { useIntersectionObserver } from '@vueuse/core';
import { OrIconV3 as script$1, IconVariant } from '../or-icon-v3/index.js';
import { OrIconButtonV3 as script$2 } from '../or-icon-button-v3/index.js';
import { OrTooltipV3 as script$3 } from '../or-tooltip-v3/index.js';
import '../OrAutocompleteV3-508d99c0.js';
import '@onereach/styles/screens.json';
import '@onereach/styles/tailwind.config.json';
import 'lodash/get';
import 'lodash/isElement';
import '../or-error-v3/index.js';
import '../or-hint-v3/index.js';
import '../or-input-box-v3/index.js';
import '../or-input-v3/index.js';
import '../OrInlineInputV3-46210775.js';
import '../or-inline-input-box-v3/index.js';
import '../or-text-v3/index.js';
import '../or-label-v3/index.js';
import '../or-loader-v3/index.js';
import './index.js';
import '../or-popover-v3/index.js';
import '@floating-ui/dom';
import '../or-bottom-sheet-v3/index.js';
import '../or-overlay-v3/index.js';
import '../or-teleport-v3/index.js';
import '../or-tag-input-v3/index.js';
import '../or-tags-v3/index.js';
import '../or-button-v3/index.js';
import '../or-tag-v3/index.js';

const MenuItem = [
// Group
'group',
// Layout
'layout-row',
// Spacing
'px-lg md:px-sm', 'py-sm+ md:py-sm', 'gap-sm md:gap-sm',
// Interactivity
'interactivity-click',
// Typography
'typography-body-2-regular md:typography-caption-regular',
// Typography (selected)
'selected:typography-body-2-semibold selected:md:typography-caption-semibold',
// Theme
'theme-preset-3-primary', 'dark:theme-preset-3-primary-dark', 'theme-foreground-outline', 'dark:theme-foreground-outline-dark',
// Theme (selected)
'selected:theme-foreground-default', 'dark:selected:theme-foreground-default-dark', 'selected:bg-primary-opacity-0-08', 'dark:selected:bg-primary-opacity-0-08-dark',
// Theme (hover)
'hover:md:theme-foreground-default', 'dark:hover:md:theme-foreground-default-dark',
// Theme (active)
'active:theme-foreground-default', 'dark:active:theme-foreground-default-dark'];
const MenuItemIcon = [
// Iconography (hover)
'group-hover:iconography-filled'];
const MenuItemIconSelected = [
// Iconography (selected)
'selected:iconography-filled'];

var script = defineComponent({
  name: 'OrMenuItem',
  components: {
    OrIcon: script$1,
    OrIconButton: script$2,
    OrTooltip: script$3
  },
  props: {
    icon: {
      type: [String, Object],
      default: undefined
    },
    closeButton: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tooltipText: {
      type: String,
      default: ''
    }
  },
  emits: ['click', 'focus', 'blur', 'close'],
  expose: ['root'],
  setup(props) {
    // Refs
    const root = ref();
    const content = ref();
    const tooltip = ref();
    const isRootVisible = ref(false);
    const {
      stop
    } = useIntersectionObserver(root, ([{
      isIntersecting
    }]) => {
      isRootVisible.value = isIntersecting;
    });
    // Styles
    const rootStyles = computed(() => ['or-menu-item-v3', ...MenuItem]);
    const iconStyles = computed(() => [...MenuItemIcon, ...(props.selected ? MenuItemIconSelected : [])]);
    const iconProps = computed(() => {
      return typeof props.icon === 'string' ? {
        icon: props.icon,
        variant: IconVariant.Inherit
      } : {
        variant: IconVariant.Inherit,
        ...props.icon
      };
    });
    // Tooltip display logic
    const isTooltipShown = computed(() => {
      if (isRootVisible.value) {
        return content.value !== undefined && content.value.clientWidth < content.value.scrollWidth;
      }
      return false;
    });
    return {
      content,
      root,
      tooltip,
      rootStyles,
      iconStyles,
      isTooltipShown,
      iconProps,
      isRootVisible,
      stop
    };
  }
});

const _hoisted_1 = ["tabindex", "selected", "disabled"];
const _hoisted_2 = /*#__PURE__*/createElementVNode("div", {
  class: /*#__PURE__*/normalizeClass(['grow'])
}, null, -1 /* HOISTED */);
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrIcon = resolveComponent("OrIcon");
  const _component_OrIconButton = resolveComponent("OrIconButton");
  const _component_OrTooltip = resolveComponent("OrTooltip");
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles),
    tabindex: !_ctx.disabled ? 0 : undefined,
    selected: _ctx.selected,
    disabled: _ctx.disabled,
    onClick: _cache[3] || (_cache[3] = $event => _ctx.$emit('click', $event)),
    onFocus: _cache[4] || (_cache[4] = $event => _ctx.$emit('focus', $event)),
    onBlur: _cache[5] || (_cache[5] = $event => _ctx.$emit('blur', $event))
  }, [_ctx.icon && _ctx.iconProps.icon ? (openBlock(), createBlock(_component_OrIcon, mergeProps({
    key: 0,
    class: _ctx.iconStyles
  }, _ctx.iconProps), null, 16 /* FULL_PROPS */, ["class"])) : createCommentVNode("v-if", true), createElementVNode("div", {
    ref: "content",
    class: normalizeClass(['truncate', 'w-full']),
    onMouseover: _cache[0] || (_cache[0] = $event => _ctx.tooltip && _ctx.tooltip.open()),
    onMouseout: _cache[1] || (_cache[1] = $event => _ctx.tooltip && _ctx.tooltip.close())
  }, [renderSlot(_ctx.$slots, "default")], 544 /* NEED_HYDRATION, NEED_PATCH */), _ctx.closeButton ? (openBlock(), createElementBlock(Fragment, {
    key: 1
  }, [_hoisted_2, createVNode(_component_OrIconButton, {
    icon: 'close',
    disabled: _ctx.disabled,
    onClick: _cache[2] || (_cache[2] = withModifiers($event => _ctx.$emit('close'), ["stop"]))
  }, null, 8 /* PROPS */, ["disabled"])], 64 /* STABLE_FRAGMENT */)) : createCommentVNode("v-if", true), _ctx.isTooltipShown ? (openBlock(), createBlock(_component_OrTooltip, {
    key: 2,
    ref: "tooltip",
    content: _ctx.tooltipText,
    trigger: _ctx.root
  }, null, 8 /* PROPS */, ["content", "trigger"])) : createCommentVNode("v-if", true)], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_1);
}

script.render = render;
script.__file = "src/components/or-menu-item-v3/OrMenuItem.vue";

export { script as OrMenuItemV3 };
